export function GeneralDocsSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/general-docs.svg'"></ng-include>`
    }
}